import type { VisionParameterResult } from '../types/model';

type Props = { results: VisionParameterResult[] };

function confidenceClass(c: number): string {
  if (c >= 0.85) return 'conf-high';
  if (c >= 0.6) return 'conf-medium';
  if (c >= 0.3) return 'conf-low';
  return 'conf-unreliable';
}

function confidenceLabel(c: number): string {
  if (c >= 0.9) return 'Sehr hoch';
  if (c >= 0.75) return 'Hoch';
  if (c >= 0.5) return 'Mittel';
  if (c >= 0.25) return 'Niedrig';
  return 'Nicht zuverlässig';
}

function formatValue(value: number | null, unit: string): string {
  if (value === null) return 'Nicht bestimmbar';
  if (Number.isInteger(value)) return `${value} ${unit}`.trim();
  return `${value.toFixed(1)} ${unit}`.trim();
}

export function ResultsView({ results }: Props) {
  return (
    <div className="results-list">
      <div className="results-header">
        <span className="small hint">Modell-Konfidenz (keine analytische Messsicherheit)</span>
      </div>
      {results.map((r, idx) => (
        <details key={idx} className="result-card">
          <summary>
            <span className="param-name">{r.parameter}</span>
            <span className="param-value">{formatValue(r.estimated_value, r.unit)}</span>
            <span className={`param-confidence ${confidenceClass(r.model_confidence)}`}>{confidenceLabel(r.model_confidence)}</span>
          </summary>
          <div className="result-detail">
            <p>Modell-Konfidenz: {(r.model_confidence * 100).toFixed(0)}%</p>
            {r.lower_reference !== null && r.upper_reference !== null && (
              <p>Referenzbereich: {r.lower_reference} – {r.upper_reference} {r.unit}</p>
            )}
            {r.interpolation_fraction !== null && r.interpolation_fraction > 0 && (
              <p>Interpolationsanteil: {(r.interpolation_fraction * 100).toFixed(0)}% zwischen {r.lower_reference} und {r.upper_reference}</p>
            )}
            <p>Interpoliert: {r.interpolated ? 'Ja' : 'Nein'}</p>
            <p>Status: {r.status}</p>
            {r.test_field_description && <p>Testfeld: {r.test_field_description}</p>}
            {r.reference_row_description && <p>Referenzzeile: {r.reference_row_description}</p>}
            <p>Begründung: {r.reasoning_short}</p>
          </div>
        </details>
      ))}
    </div>
  );
}
